<template>
  <div :class="$style.sharedChatWindow">
    <div :class="$style.messagesContainer" ref="messagesContainer">
      <div :class="[$style.messages, 'chat-window__messages']">
        <message
          v-for="message in messages"
          :message="message"
          :class="$style.message"
          :key="message.id"
        />
      </div>
    </div>
    <p :class="$style.errorMessage" v-show="error">{{ error }}</p>
    <div v-if="!readOnly" :class="$style.inputContainer">
      <emoji-input
        v-model="message"
        :class="$style.input"
        :placeholder="placeholder || 'Type here'"
        :allowNewLine="false"
        :focus="focus"
        @enterKey="submitMessage"
      />
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Message from "./message/message";
  import EmojiInput from "vue-components/emoji-input/emoji-input";

  export default {
    components: {
      Message,
      EmojiInput
    },
    props: {
      messages: { type: Array },
      requestUrl: { type: String },
      requestParams: { type: Function },
      focus: { type: Boolean },
      saveOnDestroy: { type: Boolean, default: false },
      readOnly: { type: Boolean, default: false },
      placeholder: { type: String },
      errorName: { type: String }
    },
    data() {
      return {
        message: "",
        error: null
      };
    },
    mounted() {
      this.scrollToBottom();
    },
    beforeDestroy() {
      if (this.saveOnDestroy) {
        this.submitMessage();
      }
    },
    methods: {
      submitMessage() {
        const message = this.message;

        if (message === "") {
          return;
        }

        axios
          .post(this.requestUrl, this.requestParams(message))
          .then(() => {
            // Clear input immediately after Enter key
            // is pressed. Prevent <emoji-input> to update
            // message after it is changed here.
            this.$nextTick(() => (this.message = ""));
          })
          .catch(error => {
            this.error = error.response.data.errors[this.errorName][0];
            this.message = message;
          });
      },
      scrollToBottom() {
        const el = this.$refs.messagesContainer;
        el.scrollTop = el.scrollHeight - el.clientHeight;
      }
    },
    watch: {
      messages() {
        // wait for message to be inserted into the DOM
        this.$nextTick(this.scrollToBottom);
      },
      message(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.error = null;
        }
      }
    }
  };
</script>

<style module lang="less" src="./chat-window.less"></style>



// WEBPACK FOOTER //
// chat-window.vue?38c1db8b